<template>
    <div>
        <div class="d-flex align-items-center">
            <animal-link :animal="event['animal']" />
<!--            <div class="flex-grow-0 d-flex align-items-center  mr-1">-->
<!--                <animal-avatar :thumbnail-absolute-path="event.getAvatarAbsolutePath()" :species="event.animal.species" />-->
<!--                <div class="d-flex flex-column">-->
<!--                    <small>{{ event.animal.speciesName }}, {{ lowerCaseBreedName }}</small>-->
<!--                    <span class="text-secondary">-->
<!--                        <small>№{{ event.animal.regNumber }}</small>-->
<!--                        <small v-if="event.animal.shelterRegNumber">, {{ event.animal.shelterRegNumber }}</small>-->
<!--                        <small v-if="event.animal.labelId">, бирка {{ event.animal.labelId }}</small>-->
<!--                        <small v-if="event.animal.chipId">, чип {{ event.animal.chipId }}</small>-->
<!--                    </span>-->
<!--                </div>-->
<!--            </div>-->
            <div class="flex-grow-0" v-if="removable">
                <b-button variant="outline-secondary" class="border-0" @click="remove" v-b-tooltip="'Удалить'">
                    <b-icon icon="x" />
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>

    import dog from '../../../../assets/img/dog.png'
    import cat from '../../../../assets/img/cat.png'
    import httpClient from "../../../../http";
    import api from "../../../../api";
    import AnimalAvatar from "../../Animals/AnimalAvatar";
    import AnimalLink from "@/pages/AppPages/Animals/AnimalLink.vue";

    export default {
        name: "CatchingExistingEvent",
        components: {AnimalLink, AnimalAvatar},
        props: {
            event: { type: Object, default: () => { return {} }},
            removable: { type: Boolean, default: false }
        },
        // computed: {
        //     lowerCaseBreedName() {
        //         return this.event.animal.breedName.toString().toLowerCase();
        //     }
        // },
        methods: {
            remove() {
                const vm = this;
                const url = api.events.default.detail(this.event.id);
                httpClient.delete(url).then((response) => {
                        this.$emit('catching-existing-event-removed', this.event.id);
                    }).catch((reason) => {
                        vm.$bvToast.toast('Не удалось удалить мероприятие',
                            {title: 'Ошибка', variant: 'danger'})
                    })
            }
        }

    }
</script>

<style scoped>

</style>